<template>
  <div class="service-card">
    <div class="service-card-image-wrap">
      <img :src="getCardImage(image)" :alt="title" class="service-card-image" loading="lazy" width="400" height="220" />
      <div class="service-card-image-overlay"></div>
      <span v-if="price" class="service-card-badge">From ${{ price }}</span>
    </div>
    <div class="service-card-body">
      <h3 class="service-card-title">{{ title }}</h3>
      <p class="service-card-description">{{ description }}</p>

      <ul v-if="details && details.length" class="service-card-details">
        <li v-for="(detail, index) in details" :key="index">
          <span class="detail-check" aria-hidden="true">✓</span>
          {{ detail.description }}
        </li>
      </ul>

      <div class="service-card-actions">
        <router-link to="/contactus" class="btn-service-primary">Get a Quote</router-link>
        <router-link to="/gallery" class="btn-service-ghost">See Photos</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceCard',
  props: {
    title:       { type: String, required: true },
    description: { type: String },
    image:       { type: String, required: true },
    price:       { type: String, required: false },
    details:     { type: Array,  required: false },
  },
  methods: {
    getCardImage(filename) {
      return `https://www.beastmodecleanup.com/api/beastmodeimgs/${filename}`
    },
  },
}
</script>

<style scoped>
.service-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.service-card:hover {
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.14);
  transform: translateY(-3px);
}

/* Image */
.service-card-image-wrap {
  position: relative;
  overflow: hidden;
  height: 220px;
}

.service-card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.service-card:hover .service-card-image {
  transform: scale(1.04);
}

.service-card-image-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.35) 0%, transparent 60%);
}

.service-card-badge {
  position: absolute;
  bottom: 12px;
  right: 14px;
  background: #c0392b;
  color: #fff;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 20px;
  letter-spacing: 0.03em;
}

/* Body */
.service-card-body {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.service-card-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #111111;
  margin: 0 0 0.5rem;
}

.service-card-description {
  font-size: 0.92rem;
  color: #555;
  line-height: 1.6;
  margin-bottom: 1rem;
}

/* Details checklist */
.service-card-details {
  list-style: none;
  padding: 0;
  margin: 0 0 1.25rem;
  flex: 1;
}

.service-card-details li {
  font-size: 0.88rem;
  color: #444;
  padding: 5px 0;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  line-height: 1.4;
}

.service-card-details li:last-child {
  border-bottom: none;
}

.detail-check {
  color: #c0392b;
  font-weight: 700;
  flex-shrink: 0;
  margin-top: 1px;
}

/* Action buttons */
.service-card-actions {
  display: flex;
  gap: 0.75rem;
  margin-top: auto;
  padding-top: 1rem;
  flex-wrap: wrap;
}

.btn-service-primary {
  flex: 1;
  text-align: center;
  background: #c0392b;
  color: #fff;
  font-size: 0.88rem;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 6px;
  text-decoration: none;
  transition: background 0.2s ease;
  min-width: 0;
}

.btn-service-primary:hover {
  background: #96231a;
  color: #fff;
}

.btn-service-ghost {
  flex: 1;
  text-align: center;
  background: transparent;
  color: #c0392b;
  font-size: 0.88rem;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 6px;
  border: 1.5px solid #c0392b;
  text-decoration: none;
  transition: background 0.2s ease, color 0.2s ease;
  min-width: 0;
}

.btn-service-ghost:hover {
  background: #c0392b;
  color: #fff;
}

@media (max-width: 480px) {
  .service-card-actions {
    flex-direction: column;
  }
  .btn-service-primary,
  .btn-service-ghost {
    width: 100%;
    flex: none;
  }
}
</style>
